
define(
	'Code25.CaterpartsGlobal.Balance'
	, [
		"Utils"
	]
	, function (
		Utils
	) {
		'use strict';
		return {
			mount: function mount(container) {

				var BalanceView = require("Balance.View");
				if (BalanceView) {
					if (BalanceView.BalanceView) {
						BalanceView = BalanceView.BalanceView;
					}
					_.extend(BalanceView.prototype, {


						getContext: _.wrap(BalanceView.prototype.getContext, function (getContext) {


							var res = getContext.apply(this, _.rest(arguments));

							// console.log(res);

							var percentage = Math.min(
								(this.model.get('balance') * 100) / this.model.get('creditlimit'),
								100
							);
							var unbilledpercentage = Math.min(
								(Math.max(0,this.model.get('unbilledorders')) * 100) / this.model.get('creditlimit'),
								100
							);

							res.percentage = percentage;
							res.unbilledpercentage=unbilledpercentage;
							res.isPercentageGreaterThan8 = (percentage+unbilledpercentage) > 8;
							res.isPercentageLowertThan92 = (percentage+unbilledpercentage) < 92;

							res.unbilledordersFormatted = this.model.get('unbilledorders_formatted');

							res.balanceAvailableFormatted = Utils.formatCurrency(Math.max(0, this.model.get('creditlimit') - Math.max(0,this.model.get('unbilledorders')) - this.model.get('balance')));
							return res;

						})
					});
				}

			}

		}

	});
